export default {"src":"/_next/static/media/HRL.35b3fcf3.svg","height":18,"width":18};